<template>
  <!-- 出库单详情 -->
  <div class="form">
    <div class="container">
      <!-- 上方表单 -->
      <el-form ref="basicForm" :model="formData" label-width="110px">
        <el-row>
          <el-col span="6">
            <el-form-item label="项目名称：" prop="projectId" required>
              <el-select style="width: 100%" v-model="formData.projectId" disabled>
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="出库单号：" prop="outboundNo">
              <el-input v-model="formData.outboundNo" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="出库类型：" prop="type" required>
              <el-select style="width: 100%" v-model="formData.type" disabled>
                <el-option
                  v-for="(item, index) in typeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <template v-if="orderType == TYPE_MAP.USE">
            <el-col span="6">
              <el-form-item label="领用申请单：" prop="linkNo">
                <el-input v-model="formData.linkNo" disabled></el-input>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="orderType == TYPE_MAP.TRANSFER">
            <el-col span="6">
              <el-form-item label="调拨单号：" prop="linkNo">
                <el-input v-model="formData.linkNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="调入仓库：">
                <el-select
                  style="width: 100%"
                  v-model="formData.destWarehouseId"
                  placeholder="请选择 仓库"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="调出仓库：">
                <el-select
                  style="width: 100%"
                  v-model="formData.originWarehouseId"
                  placeholder="请选择 仓库"
                  disabled
                >
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="orderType == TYPE_MAP.USE || orderType == TYPE_MAP.PURCHASE">
            <el-col span="6">
              <el-form-item label="出库仓库：" prop="warehouseId" required>
                <el-select style="width: 100%" v-model="formData.warehouseId" disabled>
                  <el-option
                    v-for="(item, index) in warehouseList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="orderType == TYPE_MAP.USE">
            <el-col span="6">
              <el-form-item label="领用部门：">
                <el-select style="width: 100%" v-model="formData.requisitionDeptName" disabled>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item label="领用人：">
                <el-select style="width: 100%" v-model="formData.requisitionUserName" disabled>
                </el-select>
              </el-form-item>
            </el-col>
          </template>
          <template v-if="orderType == TYPE_MAP.PURCHASE">
            <el-col span="6">
              <el-form-item label="订单号：" prop="linkNo">
                <el-input v-model="formData.linkNo" disabled></el-input>
              </el-form-item>
            </el-col>
          </template>
          <el-col span="6">
            <el-form-item label="经办人：" prop="handleUser">
              <el-input v-model="formData.handleUser" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="联系电话：" prop="tel">
              <el-input v-model="formData.tel" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注说明：" prop="remark">
          <el-input type="textarea" :rows="3" v-model="formData.remark" disabled />
        </el-form-item>
      </el-form>
      <hr />
      <!-- 物料区域 -->
      <h3>物料明细</h3>
      <avue-crud
        :option="goodsTableOption"
        :data="goodsTableData"
        :page.sync="goodsTablePage"
        @on-load="loadGoodsPageData"
      >
        <template slot="price" slot-scope="{ row }">
          {{ tool.money_format_allowvoid(row.price) }}
        </template>
        <template slot="outboundPrice" slot-scope="{ row }">
          {{ tool.money_format_allowvoid(row.outboundPrice) }}
        </template>
      </avue-crud>
      <div class="sum-tips" v-if="formData">
        <div style="color: red;">小数位数：单价2位，金额2位，超出部分将四舍五入</div>
        <div>
          合计出库数量：<span style="color: blue;">{{ formData.outboundNum }}</span
          >&nbsp;&nbsp;合计金额：<span style="color: red;">{{ formData.outboundAmount }}</span>
        </div>
      </div>
      <hr />
      <!-- 附件区域 -->
      <h3>附件</h3>
      <avue-crud :option="attachTableOption" :data="attachList">
        <template slot="operate" slot-scope="{ row }">
          <i class="el-icon-download" style="cursor: pointer;" @click="downloadAttach(row)"></i>
        </template>
        <template slot="extension" slot-scope="{ row }">
          <i
            v-if="['.png', '.jpg', '.jpeg'].includes(row.extension)"
            class="el-icon-picture-outline"
          ></i>
          <i
            v-else-if="['.xlx', '.xlsx', '.doc', '.docx', '.ppt', '.pptx'].includes(row.extension)"
            class="el-icon-document"
          ></i>
          <i v-else class="el-icon-folder"></i>
        </template>
      </avue-crud>
    </div>
  </div>
</template>

<script>
import { getProjectListApi, getDictApi, getWarehouseListApi } from '@/api/warehouse/index';
import { getDetailApi } from '@/api/warehouse/out';
import { downloadFile } from '@/api/crmedical/contract/add';

export default {
  name: 'WarehouseOutForm',
  props: ['projectId', 'orderId', 'orderType'],
  data() {
    return {
      // 出库类型映射后端的字典配置
      TYPE_MAP: {
        USE: 1, // 领用出库
        TRANSFER: 2, // 调拨出库
        PURCHASE: 4, // 采购退货
      },
      // 项目列表
      projectList: [],
      // 仓库列表
      warehouseList: [],
      // 出库状态列表
      typeList: [],
      // 上方表单数据
      formData: {
        projectId: '',
        warehouseId: '',
        type: '',
      },
      // 附件列表
      attachList: [],
      // 物料明细的总列表数据
      goodsListData: [],
      // 物料明细的单页表格数据
      goodsTableData: [],
      // 物料明细的表格分页信息
      goodsTablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 物料明细的表格配置项
      goodsTableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        index: true,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '物料类型',
            prop: 'typeName',
          },
          {
            label: '物料编码',
            prop: 'code',
          },
          {
            label: '物料名称',
            prop: 'name',
          },
          {
            label: '规格型号',
            prop: 'specification',
          },
          {
            label: '计量单位',
            prop: 'measuringUnitName',
          },
          {
            label: '单价',
            prop: 'price',
            align: 'right',
            slot: true,
          },
          {
            label: '本仓库余量',
            prop: 'stockNum',
          },
          {
            label: '本次出库数量',
            prop: 'outboundNum',
          },
          {
            label: '换算数量',
            prop: 'conversionNum',
          },
          {
            label: '本次出库金额',
            prop: 'outboundPrice',
            align: 'right',
            slot: true,
          },
          {
            label: '备注',
            prop: 'remark',
          },
        ],
      },
      // 附件的表格配置项
      attachTableOption: {
        height: 'auto',
        calcHeight: 'auto',
        index: true,
        border: true,
        dialogClickModal: false,
        refreshBtn: false,
        columnBtn: false,
        addBtn: false,
        menu: false,
        column: [
          {
            label: '操作',
            prop: 'operate',
            slot: true,
          },
          {
            label: '缩略图',
            prop: 'extension',
            slot: true,
          },
          {
            label: '附件名称',
            prop: 'originalName',
          },
          {
            label: '上传时间',
            prop: 'createTime',
          },
          {
            label: '上传人',
            prop: 'userName',
          },
        ],
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    /* 初始化数据 */
    initData() {
      // 获取项目列表
      getProjectListApi().then(({ data }) => {
        this.projectList = data || [];
      });
      // 获取仓库列表
      getWarehouseListApi({
        projectId: this.projectId,
      }).then(({ data }) => {
        this.warehouseList = data || [];
      });
      // 获取出库状态列表
      getDictApi({
        code: 'warehouse_outbound_type',
      }).then(({ data }) => {
        this.typeList = data || [];
      });
      // 获取详情
      getDetailApi({
        id: this.orderId,
      }).then(({ data }) => {
        this.formData = data;
        this.formData.type += ''; // 需要转换成字符串，否则会显示异常
        this.attachList = data.outboundFileUrlList;
        this.goodsListData = data.consumableList;
        this.goodsTablePage.total = this.goodsListData.length;
        this.goodsTablePage.currentPage = 1;
        this.loadGoodsPageData();
      });
    },
    /* 加载物料列表的单页表格数据 */
    loadGoodsPageData() {
      if (this.goodsListData.length == 0) return;
      let index = (this.goodsTablePage.currentPage - 1) * this.goodsTablePage.pageSize;
      this.goodsTableData = this.goodsListData.slice(index, index + this.goodsTablePage.pageSize);
    },
    /* 下载附件 */
    downloadAttach(row) {
      downloadFile(row.link, row.originalName);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../dialog-form.scss';

hr {
  margin: 30px 0;
}

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
/* 图标大小 */
i[class^='el-icon'] {
  font-size: 20px;
}

.sum-tips {
  display: flex;
  justify-content: space-between;
}
</style>
